var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-wrapper"},[(_vm.offert.country == 'UA')?_c('OffertUA',{attrs:{"offert":_vm.offert}}):(_vm.offert.country == 'RU')?_c('OffertRU',{attrs:{"offert":_vm.offert}}):_c('OffertEN',{attrs:{"offert":_vm.offert}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }